export const VISIBLE_DIALOG_OPTIONS = {
  NONE: 'none',
  CONTACT_EDIT: 'contact-edit-dialog',
  CONTACT_DETAIL: 'contact-detail-dialog',
  CONTACT_CONFIRM_DELETE: 'contact-confirm-delete',
  LABEL_EDIT: 'label-edit-dialog',
  LABEL_CONFIRM_DELETE: 'label-confirm-delete',
};
export const CONTACT_ADDED = 'set-on-contact-add';
export const CONTACT_DELETE_STARTED = 'set-on-contact-delete-start';
export const CONTACT_DELETE_COMPLETED = 'set-on-contact-delete-complete';
export const CONTACT_EDIT_STARTED = 'set-on-contact-edit-start';
export const CONTACT_EDIT_COMPLETED = 'set-on-contact-edit-complete';
export const CONTACT_READ_STARTED = 'set-on-contact-read-start';
export const CONTACT_READ_COMPLETED = 'set-on-contact-read-complete';
export const CONTACT_LIST_REFRESH_COMPLETED = 'set-on-contact-list-refresh-completed';
export const HIDE_VISIBLE_DIALOG = 'set-visible-dialog';

export const LABEL_ADDED = 'set-on-label-add';
export const LABEL_EDIT_STARTED = 'set-on-label-edit-start';
export const LABEL_EDIT_COMPLETED = 'set-on-label-edit-completed';
export const LABEL_DELETE_STARTED = 'set-on-label-delete-start';
export const LABEL_DELETE_COMPLETED = 'set-on-label-delete-complete';
export const LABEL_LIST_REFRESH_COMPLETED = 'set-on-label-list-refresh-completed';

export const ASSIGN_LABELS_TO_CONTACTS = 'set-on-assign-labels-to-contacts';

export const EMPTY_TEMPLATE_NAME = 'Based on Empty Template';

export const YEAR_DURATIONS = {
  week: 1,
  fortnite: 2,
  month: 4,
  twoMonths: 8,
  threeMonths: 12,
  sixMonths: 24,
  nineMonths: 36,
  quarter: 3,
  half: 6,
  full: 52,
  twoYears: 104,
  threeYears: 156,
};

export const SHOW_MILESTONES_INIT = {
  complianceLevel: false,
  policyViolation: false,
  insights: false,
};
export const DURATION_INIT = {
  complianceLevel: YEAR_DURATIONS.threeMonths,
  policyViolation: YEAR_DURATIONS.threeMonths,
  insights: YEAR_DURATIONS.quarter,
};

export const COLORS = [
  '#FA5C43',
  '#065f92',
  '#fadd87',
  '#6498fa',
  'rgba(255, 159, 64, 0.9)',
  '#BE5A83',
  '#E06469',
  '#ca4a1c',
  '#A62349',
  '#D07000',
  '#00FFCA',
];

export const SELECTED_COLORS = [
  '#ffded9',
  '#ecf5fe',
  '#f7f2e1',
  '#e4eaf5',
  '#ffecda',
  '#f8edf1',
  '#f2bfc1',
  '#fceee9',
  '#fff3e5',
  '#e5fffa',
];
